export default "__VITE_ASSET__50fb9ec4__"